import React, { useState } from 'react';
import { teamMembers } from '../mock';
import { Linkedin, Twitter, User } from 'lucide-react';

// Component for team member image with fallback
const MemberImage = ({ src, name }) => {
  const [hasError, setHasError] = useState(false);
  
  if (hasError) {
    return (
      <div className="w-full h-full rounded-full border-4 border-cyan-200 shadow-lg bg-gradient-to-br from-cyan-500 to-blue-600 flex items-center justify-center">
        <span className="text-white text-4xl font-bold">{name.charAt(0)}</span>
      </div>
    );
  }
  
  return (
    <img 
      src={src} 
      alt={name}
      className="w-full h-full object-cover rounded-full border-4 border-cyan-200 shadow-lg"
      onError={() => setHasError(true)}
    />
  );
};

const Team = () => {
  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="py-20 bg-gradient-to-r from-cyan-400 to-blue-500 text-white">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-5xl font-bold mb-6">Meet Our Team</h1>
          <p className="text-xl max-w-3xl mx-auto">
            Dedicated professionals committed to empowering the next generation of leaders.
          </p>
        </div>
      </section>

      {/* Team Grid */}
      <section className="py-20 bg-gradient-to-br from-cyan-50 to-blue-50">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12 max-w-6xl mx-auto">
            {teamMembers.map((member) => (
              <div key={member.id} className="bg-white rounded-2xl shadow-lg p-8 hover:shadow-2xl transition-all duration-300 hover:scale-105 text-center">
                <div className="relative w-48 h-48 mx-auto mb-6">
                  <MemberImage src={member.image} name={member.name} />
                </div>
                <div className="mb-6">
                  <h3 className="text-2xl font-bold mb-2 text-gray-900">{member.name}</h3>
                  <p className="text-sm text-cyan-600 font-semibold">{member.role}</p>
                </div>
                <div className="flex justify-center space-x-4">
                  {member.linkedin && (
                    <a 
                      href={member.linkedin} 
                      target="_blank" 
                      rel="noopener noreferrer" 
                      className="flex items-center justify-center w-10 h-10 bg-cyan-500 text-white rounded-full hover:bg-cyan-600 transition-colors"
                    >
                      <Linkedin size={20} />
                    </a>
                  )}
                  {member.twitter && (
                    <a 
                      href={member.twitter} 
                      target="_blank" 
                      rel="noopener noreferrer" 
                      className="flex items-center justify-center w-10 h-10 bg-blue-500 text-white rounded-full hover:bg-blue-600 transition-colors"
                    >
                      <Twitter size={20} />
                    </a>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Team;